import React from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import { Routes } from 'types';
import { Main, Login, Verification, FiConnect, Documents, Outcome } from 'views';
import { RouterScrollManager, RouterRedirectManager } from 'utils';
import { useTrackingPageView } from 'hooks';
import { config } from '_config';
import {Acceptance} from "./views/acceptance/Acceptance";
import {AcceptanceConfirmation} from "./views/acceptance-confirmation/AcceptanceConfirmation";
import { GreenIdVerification } from 'views/ach/GreenIdVerification';
import { AchConsents } from 'views/ach/AchConsents';
import { AchSubmitted } from 'views/ach/AchSubmitted';
import { SessionExpired } from 'views/session/SessionExpired';
import { AchDocumentsUpload } from 'views/ach/AchDocumentsUpload';
import { NzAmlConsents } from 'views/ach/NzAmlConsents';
import { NzAmlDocumentsUpload } from 'views/ach/NzAmlDocumentsUpload';
import { AmlNzSubmitted } from 'views/ach/AmlNzSubmitted';
import { AssistedApplyOrchestrator } from 'views/assisted-apply/AssistedApplyOrchestrator';
import { AssistedApplyPendingAcceptance } from 'views/assisted-apply/AssistedApplyPendingAcceptance';
import { AssistedApplyReferred } from 'views/assisted-apply/AssistedApplyReferred';
import { AssistedApplyClaimError } from 'views/assisted-apply/AssistedApplyClaimError';

const ROUTES = [
  Routes.init,
  Routes.verify,
  Routes.main,
  Routes.connect,
  Routes.upload,
  Routes.outcome,
  Routes.achGreenIdVerification,
  Routes.achConsents,
  Routes.nzAmlConsents,
  Routes.nzAmlDocUpload,
  Routes.amlNzSubmitted,
  Routes.sessionExpired,
];

export const RouteHandlers: React.FC = () => {
  const { pathname } = useLocation();
  const { siteSubSection, tealiumPageTitle } = config.routeConfig[pathname as Routes];
  const is404 = !ROUTES.includes(pathname as Routes);

  useTrackingPageView({ siteSubSection: is404 ? '404' : siteSubSection, pageTitle: tealiumPageTitle });

  return (
    <>
      <RouterScrollManager />
      <RouterRedirectManager />
    </>
  );
};

export const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <RouteHandlers />
      <Switch>
        <Route exact path={Routes.init}>
          <Login />
        </Route>
        <Route path={Routes.verify}>
          <Verification />
        </Route>
        <Route path={Routes.main}>
          <Main />
        </Route>
        <Route path={Routes.connect}>
          <FiConnect />
        </Route>
        <Route path={Routes.upload}>
          <Documents />
        </Route>
        <Route path={Routes.outcome}>
          <Outcome />
        </Route>
        <Route path={Routes.acceptance}>
          <Acceptance />
        </Route>
        <Route path={Routes.acceptanceConfirmation}>
          <AcceptanceConfirmation />
        </Route>
        <Route path={Routes.achConsents}>
          <AchConsents />
        </Route>
        <Route path={Routes.achGreenIdVerification}>
          <GreenIdVerification />
        </Route>
        <Route path={Routes.achSubmitted}>
          <AchSubmitted />
        </Route>
        <Route path={Routes.achDocUpload}>
          <AchDocumentsUpload />
        </Route>
        <Route path={Routes.nzAmlConsents}>
          <NzAmlConsents />
        </Route>
        <Route path={Routes.nzAmlDocUpload}>
          <NzAmlDocumentsUpload />
        </Route>
        <Route path={Routes.amlNzSubmitted}>
          <AmlNzSubmitted />
        </Route>
        <Route path={Routes.assistedApply}>
          <AssistedApplyOrchestrator />
        </Route>
        <Route path={Routes.pendingCustomerAcceptance}>
          <AssistedApplyPendingAcceptance />
        </Route>
        <Route path={Routes.assistedApplyReferred}>
          <AssistedApplyReferred />
        </Route>
        <Route path={Routes.assistedApplyClaimError}>
          <AssistedApplyClaimError />
        </Route>
        <Route path={Routes.sessionExpired}>
          <SessionExpired />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
